module.exports = "//public.getcloudapp.com/packs/media/images/spinner-bf5d1be3741cb674f3a6341d52adde5c.svg";